import { ComponentBootstrap } from '@demant/wdh-react-bootstrap';
import BlogAuthorDetailsApp from './react-blog-author-details';
var ReactBlogAuthorDetails = new ComponentBootstrap('author-details');
ReactBlogAuthorDetails.reactApp = BlogAuthorDetailsApp;
ReactBlogAuthorDetails.run();